import { ROUTE_LOGIN_SEARCH_PARAM } from '../../../config/constants';
import type { MentalBalanceRouteName, RouterConfig } from '../types';

// Pages.
import PageAccount from '../../../pages/Account';
import PageBadges from '../../../pages/Badges';
import PageDiaryAdd from '../../../pages/Diary/Add';
import PageDiaryOverview from '../../../pages/Diary/Overview';
import PageLogin from '../../../pages/Login';
import PageLogout from '../../../pages/Logout';
import PageOnboarding from '../../../pages/Onboarding';
import PageResetPassword from '../../../pages/ResetPassword';
import PageValidateEmail from '../../../pages/ValidateEmail';

const routesConfigMentalBalance: RouterConfig<MentalBalanceRouteName> = {
  accountBase: {
    basePath: '/account',
    nl: '/nl/account',
    en: '/en/account',
    type: 'private',
    exact: false,
    component: PageAccount,
  },
  badges: {
    basePath: '/badges',
    nl: '/nl/badges',
    en: '/en/badges',
    type: 'private',
    component: PageBadges,
  },
  diaryAdd: {
    basePath: '/dagboek/nieuwe-ervaring',
    nl: '/nl/dagboek/nieuwe-ervaring',
    en: '/en/diary/new-entry',
    type: 'private',
    component: PageDiaryAdd,
  },
  diaryOverview: {
    basePath: '/dagboek',
    nl: '/nl/dagboek',
    en: '/en/diary',
    type: 'private',
    component: PageDiaryOverview,
  },
  login: {
    basePath: '/inloggen',
    nl: '/nl/inloggen',
    en: '/en/login',
    type: 'public',
    component: PageLogin,
    search: `?${ROUTE_LOGIN_SEARCH_PARAM}`,
  },
  logout: {
    basePath: '/user/logout',
    nl: '/nl/user/logout',
    en: '/en/user/logout',
    type: 'private',
    component: PageLogout,
  },
  onboardingCredentials: {
    basePath: '/registreren/gegevens',
    nl: '/nl/registreren/gegevens',
    en: '/en/register/credentials',
    type: 'default',
    component: PageOnboarding,
  },
  resetPassword: {
    basePath: '/user/reset/:uid/:timestamp/:hash',
    nl: '/nl/user/reset/:uid/:timestamp/:hash',
    en: '/en/user/reset/:uid/:timestamp/:hash',
    type: 'default',
    component: PageResetPassword,
  },
  resetPasswordLogin: {
    basePath: '/user/reset/:uid/:timestamp/:hash/login',
    nl: '/nl/user/reset/:uid/:timestamp/:hash/login',
    en: '/en/user/reset/:uid/:timestamp/:hash/login',
    type: 'default',
    component: PageResetPassword,
  },
  resetPasswordRequest: {
    basePath: '/wachtwoord-vergeten',
    nl: '/nl/wachtwoord-vergeten',
    en: '/en/forgot-password',
    type: 'default',
    component: PageResetPassword,
  },
  validateEmail: {
    basePath: '/validate/:uid/:timestamp/:hash',
    nl: '/nl/validate/:uid/:timestamp/:hash',
    en: '/en/validate/:uid/:timestamp/:hash',
    type: 'default',
    component: PageValidateEmail,
  },
};

export default routesConfigMentalBalance;
